import React from 'react'
import MaskIcon from './icons/mask.svg'
import TissueIcon from './icons/tissue.svg'
import SocialDistanceIcon from './icons/social-distance.svg'
import CongregatingIcon from './icons/congregating.svg'
import MobilePayIcon from './icons/mobile-pay.svg'
import NoFoodOrDrinkIcon from './icons/no-food-or-drink.svg'
import TemperatureCheckIcon from './icons/temperature-check.svg'
import DisinfectIcon from './icons/disinfect.svg'
import SeatsIcon from './icons/seats.svg'
import { HealthIconType } from '../../models/health-ask'

const HealthIcon = ({ type, ...props }: { type: HealthIconType }) => {
  switch (type) {
    case HealthIconType.Mask:
      return <MaskIcon {...props} />
    case HealthIconType.Tissue:
      return <TissueIcon {...props} />
    case HealthIconType.SocialDistance:
      return <SocialDistanceIcon {...props} />
    case HealthIconType.Congregating:
      return <CongregatingIcon {...props} />
    case HealthIconType.MobilePay:
      return <MobilePayIcon {...props} />
    case HealthIconType.NoFoodOrDrink:
      return <NoFoodOrDrinkIcon {...props} />
    case HealthIconType.TemperatureCheck:
      return <TemperatureCheckIcon {...props} />
    case HealthIconType.Disinfect:
      return <DisinfectIcon {...props} />
    case HealthIconType.Seats:
      return <SeatsIcon {...props} />
    default:
      return null
  }
}

export default HealthIcon
